// SEO Helper functions for internal linking

export const slugify = (text) => {
  if (!text || typeof text !== 'string') return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-');
};

// Neighborhood proximity mapping for better internal linking
export const neighborhoodProximity = {
  "jardim-bela-vista": ["parque-das-laranjeiras", "jardim-da-luz", "vila-alzira", "parque-acalanto"],
  "parque-das-laranjeiras": ["jardim-bela-vista", "jardim-da-luz", "parque-acalanto", "jardins-paris"],
  "jardim-da-luz": ["jardim-bela-vista", "parque-das-laranjeiras", "conjunto-fabiana", "vila-alzira"],
  "parque-acalanto": ["jardim-bela-vista", "parque-das-laranjeiras", "vila-alzira", "alto-da-gloria"],
  "vila-alzira": ["jardim-bela-vista", "jardim-da-luz", "conjunto-fabiana", "parque-acalanto"],
  "conjunto-fabiana": ["jardim-da-luz", "vila-alzira", "jardins-paris", "sitios-santa-luzia"],
  "jardins-paris": ["parque-das-laranjeiras", "conjunto-fabiana", "sitios-santa-luzia", "jardim-bela-vista"],
  "sitios-santa-luzia": ["conjunto-fabiana", "jardins-paris", "alto-da-gloria", "setor-jardim-goias"],
  "alto-da-gloria": ["parque-acalanto", "sitios-santa-luzia", "setor-jardim-goias", "setor-pedro-ludovico"],
  "setor-jardim-goias": ["alto-da-gloria", "sitios-santa-luzia", "setor-pedro-ludovico", "parque-atheneu"],
  "setor-pedro-ludovico": ["alto-da-gloria", "setor-jardim-goias", "parque-atheneu", "chacara-do-governador"],
  "parque-atheneu": ["setor-jardim-goias", "setor-pedro-ludovico", "chacara-do-governador", "jardim-mariliza"],
  "chacara-do-governador": ["setor-pedro-ludovico", "parque-atheneu", "jardim-mariliza", "parque-trindade"],
  "jardim-mariliza": ["parque-atheneu", "chacara-do-governador", "parque-trindade", "jardim-olimpico"],
  "parque-trindade": ["chacara-do-governador", "jardim-mariliza", "jardim-olimpico", "jardins-milao"],
  "jardim-olimpico": ["jardim-mariliza", "parque-trindade", "jardins-milao", "vila-redencao"],
  "jardins-milao": ["parque-trindade", "jardim-olimpico", "vila-redencao", "jardim-bela-vista"],
  "vila-redencao": ["jardim-olimpico", "jardins-milao", "jardim-bela-vista", "parque-das-laranjeiras"]
};

export const getNearbyNeighborhoods = (currentNeighborhood, allNeighborhoods) => {
  const currentSlug = slugify(currentNeighborhood);
  const proximityList = neighborhoodProximity[currentSlug] || [];
  
  // Get neighborhoods from proximity map
  const nearby = allNeighborhoods.filter(n => 
    proximityList.includes(slugify(n))
  );
  
  // If we have less than 4, fill with random ones
  if (nearby.length < 4) {
    const remaining = allNeighborhoods
      .filter(n => slugify(n) !== currentSlug && !nearby.includes(n))
      .slice(0, 4 - nearby.length);
    nearby.push(...remaining);
  }
  
  return nearby.slice(0, 4);
};

export const getCityName = (slug) => {
  if (slug.includes('aparecida')) return 'Aparecida de Goiânia';
  return 'Goiânia';
};

export const getServiceTypeFromSlug = (slug) => {
  if (slug.includes('estetica-automotiva')) return 'Estética Automotiva';
  if (slug.includes('lavagem-detalhada')) return 'Lavagem Detalhada';
  if (slug.includes('lavagem-completa')) return 'Lavagem Completa';
  if (slug.includes('detalhamento-automotivo')) return 'Detalhamento Automotivo';
  return 'Lava Jato';
};
